<template>
  <div>
    <el-container>
      <el-header class="navbar">
        <TheNavbar @refresh="refreshToken"/>
      </el-header>
      <el-container>
        <TheSidebar v-if="isApp"/>
        <TheContent :sidebar="isApp"/>
      </el-container>
    </el-container>
    <Refresh v-if="isApp"
             ref="refresh"/>
  </div>
</template>

<script>
import TheNavbar from './layout/TheNavbar.vue';
import TheSidebar from './layout/TheSidebar.vue';
import TheContent from './layout/TheContent.vue';
import Refresh from './components/session/Refresh.vue';

export default {
  name: 'TheLayout',
  components: {
    Refresh,
    TheNavbar,
    TheSidebar,
    TheContent,
  },
  methods: {
    refreshToken() {
      this.$refs.refresh.open();
    },
  },
  computed: {
    isApp() {
      return this.$route.name !== 'Login';
    },
  },
};
</script>

<style lang="scss" scoped>
  .navbar {
    padding: 0;
    height: 50px !important;
  }
</style>
